<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-header">
                <!-- holaaaaaa -->
            </div>
            <div class="card-body" v-if="isLoading === true">
                <loader></loader>
            </div>
            <div class="card-body" v-else>
                <table class="table table-hover" id="tableID">
                    <thead>
                        <tr>
                            <th scope="col">{{ $t("lang.label_category_name") }}</th>
                            <th scope="col">{{ $t("lang.label_addition_name") }}</th>
                            <th scope="col">{{ $t("lang.label_price") }}</th>
                            <th scope="col" style="width: 10px">
                                {{ $t("lang.msj_status") }}
                            </th>
                            <th scope="col" style="width: 10px">
                                {{ $t("lang.label_del") }}
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="result.length === 0">
                        <tr>
                            <th colspan="10">
                                <div style="text-align: center">SIN REGISTRO</div>
                            </th>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr v-for="(i, index) in result" :key="index">
                            <td>
                                {{ i.nameExtra }}
                            </td>
                            <td>
                                <input
                                    type="text"
                                    @change="editCampN(i, index)"
                                    :maxlength="100"
                                    v-model="i.name"
                                    class="form-control editables"
                                />
                            </td>
                            <td>
                                {{ currency
                                }}<input
                                    type="number"
                                    max="999999"
                                    min="1"
                                    @change="editCampN(i, index)"
                                    :maxlength="100"
                                    v-model="i.price"
                                    class="form-control editables"
                                />
                            </td>
                            <td>
                                <div class="onoffswitch">
                                    <input
                                        type="checkbox"
                                        :id="'cat' + i.id"
                                        :checked="i.status"
                                        class="onoffswitch-checkbox"
                                        @click="changeStatus(i)"
                                    />
                                    <label class="onoffswitch-label" :for="'cat' + i.id">
                                        <span class="onoffswitch-inner"></span>
                                        <span class="onoffswitch-switch"></span>
                                    </label>
                                </div>
                            </td>
                            <td>
                                <a class="btn btn-danger btn-sm mr-2" @click="deletes(i)">
                                    <i class="fas fa-trash fa-lg"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader";
export default {
    name: "listExtraAdicional",
    components: {
        Loader,
    },
    data () {
        return {
            isLoading: false,
            result: [],
            f: {
                org_id: window.localuserdata,
                user_id: window.localAccountID,
                active: "",
                cat_id: 0,
                id: 0,
                incluir: 0,
                name: "",
                price: 0,
                required: 0,
                status: 0,
            },
            currency: localStorage.getItem("currency"),
        }
    },
    created () {
        this.getData();
    },
    methods: {
        getData() {
            this.isLoading = true;
            let url = "/menu/listextraadicional";
            window.master
                .post(url, this.f)
                .then((response) => {
                    // console.log('data listEstra',response.data.res)
                    let u = response.data.res;
                    let m = [];
                    for (const i in u) {
                        let o = u[i].extras;
                        for (const j in o) {
                            m.push(o[j]);
                        }
                    }
                    this.result = m;
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },
        changeStatus(b) {
            let active = 0;
            if (b.status) {
                active = 0;
            } else {
                active = 1;
            }
            this.f.id = b.id;
            this.f.price = b.price;
            this.f.incluir = b.incluir;
            this.f.name = b.name;
            this.f.price = b.price;
            this.f.required = b.required;
            this.f.status = active;
            this.f.cat_id = b.extra_cat_id;
            let url = "/menu/category/extras/editAdi";
            window.master
                .post(url, this.f)
                .then((response) => {
                    b.status = !b.status;
                    console.log(response.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deletes(i) {
            this.f.id = i.id;
            this.f.cat_id = i.extra_cat_id;
            window.master
                .post("/menu/category/extras/delAdis", this.f)
                .then((response) => {
                    console.log(response.data.rs);
                    if (response.data.rs === false) {
                        this.$swal({
                            title: "Error",
                            text: "you cannot delete this aditional",
                            type: "warning",
                            showCancelButton: false,
                            confirmButtonColor: "#3085d6",
                        });
                    } else {
                        this.isLoading = true;
                        this.$swal.fire({
                            type: "success",
                            title: "Deleted!",
                            text: "Deleted aditional Successful",
                            showConfirmButton: false,
                            timer: 2000,
                        });
                        this.getData();
                        this.isLoading = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },
        editCampN(b) {
            let name = b.name.length;
            let price;
            if (b.price === "" || b.price === null) {
                price = "";
            } else {
                price = b.price;
            }
            if (price === "" || name === 0) {
                this.$swal({
                    title: "Error",
                    text: "It is Empty",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#3085d6",
                });
            } else {
                this.f.id = b.id;
                this.f.price = b.price;
                this.f.incluir = b.incluir;
                this.f.name = b.name;
                this.f.price = b.price;
                this.f.required = b.required;
                this.f.status = b.status;
                this.f.cat_id = b.extra_cat_id;
                let url = "/menu/category/extras/editAdi";
                window.master
                    .post(url, this.f)
                    .then((response) => {
                        console.log(response.data);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
    },
}
</script>
<style>
.onoffswitch-checkbox {
    display: none;
}
.onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    text-align: left;
    //border: 1px solid #fff;
    border-radius: 20px;
}
.onoffswitch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.1s ease-in 0s;
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
    display: block;
    float: left;
    width: 50%;
    height: 21px;
    padding: 0;
    line-height: 20px;
    font-size: 12px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
}
.onoffswitch-inner:before {
    content: "Encendido";
    padding-left: 10px;
    background-color: #5ac146;
    color: #ffffff;
}
.onoffswitch-inner:after {
    content: "Apagado";
    padding-right: 10px;
    background-color: #d65353;
    color: #fff;
    text-align: right;
}
.onoffswitch-switch {
    display: block;
    width: 15px;
    height: 15px;
    margin: 6px;
    background: #fff;
    position: absolute;
    top: -3px;
    bottom: 0;
    right: 33px;
    //border: 1px solid #5ac146;
    border-radius: 20px;
    transition: all 0.1s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px;
}
.form-control.editables {
    border: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    background: transparent;
    font-size: 12px;
    padding: 0;
}
.form-control {
    display: inherit !important;
    width: 90% !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}
a:not([href]):not([tabindex]) {
    color: white;
    /* color: inherit; */
    text-decoration: none;
}
</style>
